import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import medias from '../../../util/medias'
import { Card } from '@olxbr/ds-web'
import { Skeleton } from '../../atoms'
import { SkeletonAnimation } from '../../molecules'

const CardWrapper = styled(Card)`
  align-items: center;
  padding: var(--spacing-3);
  width: 100%;
  min-height: 112px;
  gap: var(--spacing-1);

  ${medias.medium`
    padding: 18px 16px;
    min-height: 90px;
    gap: var(--spacing-2);
  `}
`

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`

const CardHeader = styled.div`
  display: flex;
  align-items: center;

  ${props =>
    props.isLoading &&
    `
    flex-grow: 1;
    flex-basis: 100%;
  `}
`

const IconWrapper = styled.div`
  ${medias.medium`
    svg {
      height: 48px;
      width: 48px;
    }
  `}
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: var(--spacing-2);

  ${medias.medium`
    margin-left: var(--spacing-1);
  `}

  ${props =>
    props.isLoading &&
    `
    flex-grow: 0;
    flex-basis: 70%;
  `}
`

export const CardRectangle = ({ title, subtitle, icon, children, rightComponent, isLoading }) => {
  return (
    <CardWrapper variant="outlined" data-testid="cardRectangle">
      <ContentWrapper>
        <CardHeader isLoading={isLoading}>
          <IconWrapper>{icon}</IconWrapper>

          <TextWrapper isLoading={isLoading}>
            <span className="typo-subtitle-medium text-neutral-120">{title}</span>

            {subtitle ? (
              <span className="typo-body-medium mt-1 text-neutral-110">{subtitle}</span>
            ) : (
              isLoading && (
                <span className="typo-body-medium mt-1 text-neutral-110">
                  <SkeletonAnimation>
                    <Skeleton />
                  </SkeletonAnimation>
                </span>
              )
            )}
          </TextWrapper>
        </CardHeader>

        {rightComponent}
      </ContentWrapper>

      {children}
    </CardWrapper>
  )
}

CardRectangle.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.node,
  rightComponent: PropTypes.node,
  isLoading: PropTypes.bool,
}
